import React from 'react'

function Routes() {
    return <></>
  }
 
  Routes.global = {
    url_login: 'https://www.inventarios.gemcont.com/apiGemcont/usuarios/',
    url_ver_usuarios: 'https://www.inventarios.gemcont.com/apiGemcont/ver_usuarios/',
    url_proveedores: 'https://www.inventarios.gemcont.com/apiGemcont/compras/proveedores/',
    url_clientes: 'https://www.inventarios.gemcont.com/apiGemcont/ventas/clientes/',
    url_categorias: 'https://www.inventarios.gemcont.com/apiGemcont/inventarios/categorias/',
    url_articulos: 'https://www.inventarios.gemcont.com/apiGemcont/inventarios/articulos/'
  };
  
  export default Routes;
